/**
 * TODO(Morris): Add error reporting with DataDog.
 * @see https://www.npmjs.com/package/@datadog/browser-logs
 */
export function handleUnknownError(error: unknown): void {
    reportError(error);
}
